import { NgModule } from '@angular/core';
import { SpartacusCoreModule } from '@spartacus/core';
import {
  GlobalMessageComponentModule,
  LayoutModule,
  MediaModule,
  OutletModule,
  OutletRefModule,
  PageComponentModule,
  PageLayoutModule,
  PageSlotModule,
  RoutingModule,
  SeoModule,
} from '@spartacus/storefront';

@NgModule({
  imports: [
    SpartacusCoreModule.forRoot(),
    GlobalMessageComponentModule,
    OutletModule,
    OutletRefModule,
    PageLayoutModule,
    SeoModule,
    PageComponentModule.forRoot(),
    PageSlotModule,
    LayoutModule,
    RoutingModule.forRoot(),
    MediaModule.forRoot(),
    OutletModule.forRoot(),
  ],
  exports: [LayoutModule],
})
export class CustomBaseStorefrontModule {}
